import { createSelector } from '@ngrx/store';
import { getOrderSummary } from '../../../onlineOrder/selectors/getOrderSummary';
import { getActiveCardId } from '../../../creditCards/selectors/getActiveCardId';
import { isPayByPointsSelected } from '../../../creditCards/selectors/isPayByPointsSelected';
import { getLocationRedemptionRate } from '../../getLocationRedemptionRate';
import { getMemberRedeemableePoints } from '../../../members/selectors/getMemberRedeemablePointsTotal/get-member-redeemable-points-total';
import { canFulfillPaymentWithPointsOnly } from '../canFulfillPaymentWithPointsOnly/can-fulfill-payment-with-points-only.selector';

export const isPaymentDisabledForPayByPoints = createSelector(
    getOrderSummary,
    isPayByPointsSelected,
    getMemberRedeemableePoints,
    getLocationRedemptionRate,
    getActiveCardId,
    canFulfillPaymentWithPointsOnly,
    (orderSummary, payByPointsSelected, points, locationRedemptionRate, activeCardId, canFulfillWithPointsOnly) => {
        const total = Number(orderSummary?.Total);
        const availableBalance = points / locationRedemptionRate?.rate;
        const differentActiveCardId = activeCardId !== OLO.Enums.PAYMENT_VENDOR_SERVICE.PAY_BY_POINTS;
        const noSufficientFunds = availableBalance < total && !differentActiveCardId;
        const noAlternativePaymentMethod = !canFulfillWithPointsOnly && !differentActiveCardId;

        return payByPointsSelected && (noSufficientFunds || noAlternativePaymentMethod);
    },
);
